var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarcollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.33333H19C19.2652 2.33333 19.5196 2.21042 19.7071 1.99162C19.8946 1.77283 20 1.47609 20 1.16667C20 0.857247 19.8946 0.560501 19.7071 0.341709C19.5196 0.122917 19.2652 0 19 0H1C0.734784 0 0.48043 0.122917 0.292893 0.341709C0.105357 0.560501 0 0.857247 0 1.16667C0 1.47609 0.105357 1.77283 0.292893 1.99162C0.48043 2.21042 0.734784 2.33333 1 2.33333ZM1 8.16667H15C15.2652 8.16667 15.5196 8.04375 15.7071 7.82496C15.8946 7.60616 16 7.30942 16 7C16 6.69058 15.8946 6.39383 15.7071 6.17504C15.5196 5.95625 15.2652 5.83333 15 5.83333H1C0.734784 5.83333 0.48043 5.95625 0.292893 6.17504C0.105357 6.39383 0 6.69058 0 7C0 7.30942 0.105357 7.60616 0.292893 7.82496C0.48043 8.04375 0.734784 8.16667 1 8.16667ZM18 11.6667H1C0.734784 11.6667 0.48043 11.7896 0.292893 12.0084C0.105357 12.2272 0 12.5239 0 12.8333C0 13.1428 0.105357 13.4395 0.292893 13.6583C0.48043 13.8771 0.734784 14 1 14H18C18.2652 14 18.5196 13.8771 18.7071 13.6583C18.8946 13.4395 19 13.1428 19 12.8333C19 12.5239 18.8946 12.2272 18.7071 12.0084C18.5196 11.7896 18.2652 11.6667 18 11.6667Z",
    fill: "#EE4B22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcollapse);
export default __webpack_public_path__ + "static/media/barcollapse.dc7e65d693bb10889d3548b45c0cc94b.svg";
export { ForwardRef as ReactComponent };